import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "text-muted"
}

import { ref, onMounted, onUnmounted, useAttrs, computed } from 'vue';

import { EPINIO_TYPES } from '../types';
import Loading from '@shell/components/Loading';
import { useStore } from 'vuex';
import ResourceTable from '@shell/components/ResourceTable';
import { startPolling, stopPolling } from '../utils/polling';


export default /*@__PURE__*/_defineComponent({
  __name: 'services',
  setup(__props) {

const pending = ref(true);
const store = useStore();
const attrs = useAttrs();

onMounted(async () => {
  await Promise.all([
    store.dispatch(`epinio/findAll`, { type: EPINIO_TYPES.APP }),
    store.dispatch(
      `epinio/findAll`,
      { type: EPINIO_TYPES.SERVICE_INSTANCE }
    ),
  ]);
  pending.value = false;

  startPolling(["catalogservices", "namespaces", "applications"], store);
});

onUnmounted(() => {
  stopPolling(["catalogservices", "namespaces", "applications"]);
});

const rows = computed(() => {
  return store.getters['epinio/all'](EPINIO_TYPES.SERVICE_INSTANCE);
});

return (_ctx: any,_cache: any) => {
  const _component_LinkDetail = _resolveComponent("LinkDetail")!

  return (pending.value)
    ? (_openBlock(), _createBlock(_unref(Loading), { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ResourceTable), _mergeProps(_unref(attrs), { rows: rows.value }), {
          "cell:boundApps": _withCtx(({ row }) => [
            (row.applications.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.applications, (app, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: app.id
                    }, [
                      _createVNode(_component_LinkDetail, {
                        row: app,
                        value: app.meta.name
                      }, null, 8, ["row", "value"]),
                      _cache[0] || (_cache[0] = _createTextVNode()),
                      (index < row.applications.length - 1)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: app.id + 'i'
                          }, ", "))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, " "))
          ]),
          _: 1
        }, 16, ["rows"])
      ]))
}
}

})